import { SERIES_FRAGMENT } from 'graphql/fragments'

import { gql } from '@apollo/client'

export const GET_SERIES_ORDERED_BY_SHIUR_COUNT = gql`
  ${SERIES_FRAGMENT}
  query getSeriesOrderedByShiurCount($take: Int!, $page: Int!, $title: String) {
    getSeriesOrderedByShiurCount(take: $take, page: $page, title: $title) {
      items {
        ...SeriesInfo
      }
      meta {
        total
        next
      }
    }
  }
`
